import { motion } from "framer-motion";
import { PILOT_SUITABILITY_CRITERIA } from "@/data/content";

const LEFT_CRITERIA = PILOT_SUITABILITY_CRITERIA.slice(0, 3);
const RIGHT_CRITERIA = PILOT_SUITABILITY_CRITERIA.slice(3);

export const WhoWeAreLookingFor = () => (
  <section data-testid="who-we-are-looking-for-section" className="bg-baseLight px-6 pt-[10px] pb-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="max-w-2xl lg:mx-auto lg:max-w-none lg:text-center">
        <h2
          data-testid="pilot-candidates-headline"
          className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
        >
          Could your operation
          <br className="sm:hidden" /> be a good fit?
        </h2>
        <p data-testid="pilot-candidates-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft lg:mx-auto lg:max-w-2xl">
          We're exploring pilot opportunities with British Columbia agricultural operations
          facing one or more of the following conditions.
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-x-16 sm:grid-cols-2 lg:mt-12">
        {[LEFT_CRITERIA, RIGHT_CRITERIA].map((column, colIndex) => (
          <div key={colIndex} className="divide-y divide-borderLight border-t border-borderLight">
            {column.map((criterion) => (
              <motion.div
                key={criterion.n}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5 }}
                data-testid={`pilot-criterion-${criterion.n}`}
                className="py-7"
              >
                <div className="flex items-baseline gap-4">
                  <span className="font-mono text-sm text-teal">{criterion.n}</span>
                  <h3 className="font-heading text-lg font-semibold text-ink">{criterion.title}</h3>
                </div>
                <p className="mt-2 text-[15px] leading-relaxed text-inkSoft lg:pl-9">
                  {criterion.title === "Grid Limitations" ? (
                    <>
                      Limited grid capacity, expensive connection
                      <br className="sm:hidden" /> or extension requirements.
                    </>
                  ) : (
                    criterion.body
                  )}
                </p>
              </motion.div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);
